import React from "react";

export default function ConfirmModal({
                                         open,
                                         title = "تأیید",
                                         message,
                                         confirmText = "حذف",
                                         cancelText = "لغو",
                                         onConfirm,
                                         onCancel
                                     }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur">
            <div className="w-[400px] rounded-2xl bg-white p-6 shadow-xl">
                <h3 className="text-lg font-bold mb-3">{title}</h3>
                <p className="text-sm text-gray-600 mb-6">{message}</p>

                <div className="flex justify-end gap-2">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 rounded-xl border bg-gray-100 hover:bg-gray-200"
                    >
                        {cancelText}
                    </button>

                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700"
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
